<div class="dialog-content-wrapper edit-space-modal">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <!--    <div>-->
    @if (!type) {
      <span class="title dialog-title">{{'edit_space' | translate}}</span>
    }
    @if (type === 'sub') {
      <span class="title dialog-title">{{'edit_board' | translate}}</span>
    }
    @if (type === 'create_sub') {
      <span class="title dialog-title">{{'add_board' | translate}}</span>
    }
    <button mat-button class="mat-icon-button"
      (click)="dialogRef.close()"
      aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  <!--    </div>-->
</mat-toolbar>
<div class="m-0 content">
  <mat-form-field>
    @if (!type) {
      <input matInput [(ngModel)]="spaceName" required (keyup)="error = false">
    }
    @if (type === 'sub' || type === 'create_sub') {
      <input matInput [(ngModel)]="spaceName" required (keyup)="error = false">
    }
  </mat-form-field>
  @if (platforms && platforms.length) {
    <div>
      <mat-form-field>
        <mat-select [(ngModel)]="platformId" placeholder="{{'event.platforms' | translate}}" required>
          @for (plat of platforms; track plat.id) {
            <mat-option [value]="plat.id">
              {{plat.title}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
</div>

@if (error) {
  <div class="error">{{'enter_space_name' | translate}}</div>
}
<div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">
  <button mat-raised-button class="mat-accent mr-16" (click)="saveCat()">{{'main.save' | translate}}</button>
  <button mat-raised-button class="mat-accent mr-16" (click)="dialogRef.close(false)">{{'main.cancel' | translate}}</button>
</div>
</div>
